import PendingApplications from "../Administration/PendingApplications";

const DivisionPendingPermission = ({ role }) => {
  return (
    <>
      <PendingApplications role={role} />
    </>
  );
};

export default DivisionPendingPermission;
